import GoogleMapReact from 'google-map-react';
import { useState } from 'react';

const AnyReactComponent = ({ text }) => <div >{text}</div>;

const Map = ({ lat, lng }) => {


  console.log('data', lat, lng)

  const [center, setCenter] = useState({ lat, lng });
  const [zoom, setZoom] = useState(11);

  const mapOptions = {
    // fullscreenControl: false,
    // zoomControl: false,
    streetViewControl: false,
    mapTypeControl: false,
    styles: [
      {
        featureType: 'poi',
        elementType: 'labels',
        // stylers: [{ visibility: 'off' }],
      },
    ],
  };

  const onMapChange = ({ center, zoom }) => {
    setCenter(center);
    setZoom(zoom);
  };

  const onGoogleApiLoaded = ({
    map, 
    maps 
  }) => {
    new maps.Marker({
      position: center,
      map,
      title: 'My Marker',
    });

    new maps.Circle({
      strokeColor: '#000',
      strokeOpacity: 0.5,
      strokeWeight: 1,
      fillColor: '#FF0000',
      fillOpacity: 0.25,
      map,
      center,
      radius:  0, // 5 km in meters
    });
  };

  return (
    <div style={{
        height: '100%', 
        width: '100%' 
      }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: 'AIzaSyCg0mrxVG0ppOhCJeZmxJGuL1qdXf1Fkyc' }}
        defaultCenter={center}
        defaultZoom={zoom}
        options={mapOptions}
        onChange={onMapChange}
        onGoogleApiLoaded={onGoogleApiLoaded}
      >
        <AnyReactComponent lat={center?.lat} lng={center?.lng} text="." />
      </GoogleMapReact>
    </div>
  );
};

export default Map;
